var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.875C12.797 15.875 15.875 12.797 15.875 9C15.875 5.20304 12.797 2.125 9 2.125C5.20304 2.125 2.125 5.20304 2.125 9C2.125 12.797 5.20304 15.875 9 15.875ZM9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25ZM9.91668 11.75C9.91668 12.2562 9.50628 12.6666 9.00002 12.6666C8.49375 12.6666 8.08335 12.2562 8.08335 11.75C8.08335 11.2437 8.49375 10.8333 9.00002 10.8333C9.50628 10.8333 9.91668 11.2437 9.91668 11.75ZM7.85415 7.16664C7.85415 6.53381 8.36716 6.0208 8.99999 6.0208C9.63281 6.0208 10.1458 6.53381 10.1458 7.16664C10.1458 7.79946 9.63281 8.31247 8.99999 8.31247H8.31249V9.68747H8.99999C10.3922 9.68747 11.5208 8.55885 11.5208 7.16664C11.5208 5.77442 10.3922 4.6458 8.99999 4.6458C7.60777 4.6458 6.47915 5.77442 6.47915 7.16664H7.85415Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.488ba2ead34995f12f363db5b4c28ed0.svg";
export { ForwardRef as ReactComponent };